import {
  CircularProgress,
  Switch,
  circularProgressClasses,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Line,
  MenuDiv,
  SecurityContainer,
  SubMenuDiv,
  SubMenuPart,
} from "../Security.style";
import UserLevelFilter from "./UserLevelFilter";
import useProfile from "../../../hooks/useProfile";

const data1 = [
  // { sl: 201, Menu_name: "Dashboard", active_status: true },
  {
    menu_id: 101,
    menu: "Dashboard",
    submenu: [],
  },
  {
    menu_id: 102,
    menu: "Security",
    submenu: [
      {
        sl: 201,
        menu_id: 102,
        Menu_name: "Security",
        submenu_name: "User Level",
        active_status: true,
      },
      {
        sl: 222,
        menu_id: 102,
        Menu_name: "Security",
        submenu_name: "Security Level",
        active_status: true,
      },
      {
        sl: 223,
        menu_id: 102,
        Menu_name: "Security",
        submenu_name: "Menu Setup",
        active_status: true,
      },
      {
        sl: 224,
        menu_id: 102,
        Menu_name: "Security",
        submenu_name: "Submenu Setup",
        active_status: true,
      },
    ],
  },

  {
    menu_id: 103,
    menu: "Setup",
    submenu: [
      {
        sl: 231,
        menu_id: 103,
        Menu_name: "Setup",
        submenu_name: "User Setup",
        active_status: true,
      },
      {
        sl: 232,
        menu_id: 103,
        Menu_name: "Setup",
        submenu_name: "Occupation Setup",
        active_status: true,
      },
      {
        sl: 233,
        menu_id: 103,
        Menu_name: "Setup",
        submenu_name: "Sponsor Setup",
        active_status: true,
      },
      {
        sl: 234,
        menu_id: 103,
        Menu_name: "Setup",
        submenu_name: "Study Setup",
        active_status: true,
      },
    ],
  },

  {
    menu_id: 104,
    menu: "Volunteer Bank",
    submenu: [
      {
        sl: 241,
        menu_id: 104,
        Menu_name: "Volunteer Bank",
        submenu_name: "New Registration",
        active_status: true,
      },
      {
        sl: 242,
        menu_id: 104,
        Menu_name: "Volunteer Bank",
        submenu_name: "Registration From PRO",
        active_status: true,
      },
      {
        sl: 243,
        menu_id: 104,
        Menu_name: "Volunteer Bank",
        submenu_name: "Volunteer Bank",
        active_status: true,
      },
    ],
  },
  {
    menu_id: 105,
    menu: "Study Compliance",
    submenu: [],
  },
];

const data2 = {
  Dashboard: "1",
  Security: "0",
  Setup: "0",
  "Volunteer Bank": "1",
  "Study Compliance": "0",
};

const LevelManagement = () => {
  const dispatch = useDispatch();
  const menuLevelData = useSelector((state) => state.Data.val1);
  const [loadingIs, setIsLoading] = useState();

  const [userData] = useProfile();

  // console.log("menuLevelData", menuLevelData);
  // console.log("userData", userData);

  const { data: menuInfo = [] } = useQuery({
    queryKey: ["menuInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/get-submenu-by-module`
      );
      const data = await res.json();
      return data;
    },
  });

  // console.log("menuInfo", menuInfo);

  const {
    refetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: permissionData = [],
  } = useQuery({
    queryKey: ["permissionData", menuLevelData],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/link-permissions-get/${menuLevelData}`
      );
      const data = await res.json();
      return data;
    },
  });

  // console.log("permissionData", permissionData);

  // console.log("menuInfo", menuInfo);
  // console.log("permissionData", permissionData);

  const handleSwitchToggle = (event, data) => {
    setIsLoading(true);
    const permission22 = permissionData.find(
      (p) => p?.sa_mlinks_id == data.submenu_id
    );
    const permissionId = permission22?.sa_uglwm_link || "";

    // console.log("permission22", permissionId);

    const active = event.target.checked ? "Y" : "N";
    // console.log("active", active);
    // console.log("data", data);
    // console.log("permission", permission22);
    const formData = new FormData();
    formData.append("ug_level_id", menuLevelData);
    formData.append("sa_module_id", data.menu_id);
    formData.append("sa_mlinks_id", data.submenu_id);
    formData.append("sa_uglwm_link", permissionId);
    formData.append("active_fg", active);

    fetch(
      `${process.env.REACT_APP_API_URL}/api/update-or-create-permissions`,
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        refetch();
        // console.log("data", data);
      })
      .finally(() => setIsLoading(false));
  };

  // if (loadingIs) {
  //   return "jjjjjjjjjjjjjjjjjjjjjjjjjjjjjjj";
  // }

  return (
    <>
      <div>
        <UserLevelFilter />
      </div>
      <SecurityContainer
        style={{
          paddingTop: "2rem",
        }}
      >
        {menuInfo.map((menu) => (
          <div style={{ marginBottom: "1rem" }} key={menu.menu_id}>
            <MenuDiv>
              <div>{menu.menu}</div>
            </MenuDiv>
            <SubMenuDiv>
              {menu.submenu.map((submenu) => {
                // console.log("submenu", submenu?.submenu_id);
                const permission = permissionData.find(
                  (p) => p?.sa_mlinks_id == submenu?.submenu_id
                );
                // console.log("permission", permission);
                const isSwitchOn = permission && permission.active_fg === "Y";
                // console.log("isSwitchOn", isSwitchOn);

                return (
                  <SubMenuPart key={submenu.submenu_id}>
                    <div>{submenu.submenu_name}</div>
                    {isLoading && <CircularProgress />}
                    <div>
                      {loadingIs ? (
                        <CircularProgress />
                      ) : (
                        <Switch
                          color="success"
                          style={
                            {
                              // color: "#128378",
                            }
                          }
                          inputProps={{ "aria-label": "controlled" }}
                          checked={isSwitchOn || false}
                          // checked={isSwitchOn}
                          onChange={(event) =>
                            handleSwitchToggle(event, submenu)
                          }
                        />
                      )}
                    </div>
                  </SubMenuPart>
                );
              })}
            </SubMenuDiv>
            <Line />
          </div>
        ))}
      </SecurityContainer>
    </>
  );
};

export default LevelManagement;

{
  /* <SecurityContainer
        style={{
          paddingTop: "2rem",
        }}
      >
        {menuInfo.map((menu) => (
          <div style={{ marginBottom: "1rem" }} key={menu.menu_id}>
            <MenuDiv>
              <div>{menu.menu}</div>
            </MenuDiv>
            <SubMenuDiv>
              {menu.submenu.map((submenu) => {
                const permission = permissionData.find(
                  (p) =>
                    p.sa_mlinks_id === submenu.submenu_id && p.active_fg === "Y"
                );
                const isSwitchOn = Boolean(permission);

                console.log("isSwitchOn", isSwitchOn);

                return (
                  <SubMenuPart key={submenu.submenu_id}>
                    <div>{submenu.submenu_name}</div>
                    <div>
                      <Switch
                        color="success"
                        checked={isSwitchOn}
                        onChange={(event) => handleSwitchToggle(event, submenu)}
                      />
                    </div>
                  </SubMenuPart>
                );
              })}
            </SubMenuDiv>
            <Line />
          </div>
        ))}
      </SecurityContainer> */
}
// </>

// import { Switch } from "@mui/material";
// import { useQuery } from "@tanstack/react-query";
// import React, { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";

// import {
//   Line,
//   MenuDiv,
//   SecurityContainer,
//   SubMenuDiv,
//   SubMenuPart,
// } from "../Security.style";
// import UserLevelFilter from "./UserLevelFilter";

// const data1 = [
//   // { sl: 201, Menu_name: "Dashboard", active_status: true },
//   {
//     menu_id: 101,
//     menu: "Dashboard",
//     submenu: [],
//   },
//   {
//     menu_id: 102,
//     menu: "Security",
//     submenu: [
//       {
//         sl: 201,
//         menu_id: 102,
//         Menu_name: "Security",
//         submenu_name: "User Level",
//         active_status: true,
//       },
//       {
//         sl: 222,
//         menu_id: 102,
//         Menu_name: "Security",
//         submenu_name: "Security Level",
//         active_status: true,
//       },
//       {
//         sl: 223,
//         menu_id: 102,
//         Menu_name: "Security",
//         submenu_name: "Menu Setup",
//         active_status: true,
//       },
//       {
//         sl: 224,
//         menu_id: 102,
//         Menu_name: "Security",
//         submenu_name: "Submenu Setup",
//         active_status: true,
//       },
//     ],
//   },

//   {
//     menu_id: 103,
//     menu: "Setup",
//     submenu: [
//       {
//         sl: 231,
//         menu_id: 103,
//         Menu_name: "Setup",
//         submenu_name: "User Setup",
//         active_status: true,
//       },
//       {
//         sl: 232,
//         menu_id: 103,
//         Menu_name: "Setup",
//         submenu_name: "Occupation Setup",
//         active_status: true,
//       },
//       {
//         sl: 233,
//         menu_id: 103,
//         Menu_name: "Setup",
//         submenu_name: "Sponsor Setup",
//         active_status: true,
//       },
//       {
//         sl: 234,
//         menu_id: 103,
//         Menu_name: "Setup",
//         submenu_name: "Study Setup",
//         active_status: true,
//       },
//     ],
//   },

//   {
//     menu_id: 104,
//     menu: "Volunteer Bank",
//     submenu: [
//       {
//         sl: 241,
//         menu_id: 104,
//         Menu_name: "Volunteer Bank",
//         submenu_name: "New Registration",
//         active_status: true,
//       },
//       {
//         sl: 242,
//         menu_id: 104,
//         Menu_name: "Volunteer Bank",
//         submenu_name: "Registration From PRO",
//         active_status: true,
//       },
//       {
//         sl: 243,
//         menu_id: 104,
//         Menu_name: "Volunteer Bank",
//         submenu_name: "Volunteer Bank",
//         active_status: true,
//       },
//     ],
//   },
//   {
//     menu_id: 105,
//     menu: "Study Compliance",
//     submenu: [],
//   },
// ];

// const data2 = {
//   Dashboard: "1",
//   Security: "0",
//   Setup: "0",
//   "Volunteer Bank": "1",
//   "Study Compliance": "0",
// };

// const LevelManagement = () => {
//   const dispatch = useDispatch();
//   const menuLevelData = useSelector((state) => state.Data.val1);
//   const [loading, setIsLoading] = useState();

//   console.log("menuLevelData", menuLevelData);

//   const { data: menuInfo = [] } = useQuery({
//     queryKey: ["menuInfo"],
//     queryFn: async () => {
//       const res = await fetch(
//         "http://192.168.0.173/kyamch_ctms_backend_qa/api/get-submenu-by-module"
//       );
//       const data = await res.json();
//       return data;
//     },
//   });

//   const {
//     refetch,
//     isLoading,
//     isError,
//     error,
//     isSuccess,
//     data: menuInfoLevel = [],
//   } = useQuery({
//     queryKey: ["menuInfoLevel", menuLevelData],
//     queryFn: async () => {
//       const res = await fetch(
//         `http://192.168.0.173/kyamch_ctms_backend_qa/api/link-permissions-get/${menuLevelData}`
//       );
//       const data = await res.json();
//       return data;
//     },
//   });

//   // console.log("menuInfo", menuInfo);
//   console.log("menuInfoLevel", menuInfoLevel);
//   const userId = 1;
//   const isSwitchOn = userId === 1;

//   const handleSwitchToggle = (event, data) => {
//     setIsLoading(true);
//     const active = event.target.checked ? "Y" : "N";
//     const formData = new FormData();
//     formData.append("ug_level_id", menuLevelData);
//     formData.append("sa_module_id", data.menu_id);
//     formData.append("sa_mlinks_id", data.submenu_id);
//     formData.append("sa_uglwm_link", "");
//     formData.append("active_fg", active);

//     fetch(
//       "http://192.168.0.173/kyamch_ctms_backend_qa/api/update-or-create-permissions",
//       {
//         method: "POST",
//         body: formData,
//       }
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         console.log("data", data);
//       })
//       .finally(() => setIsLoading(false));
//   };

//   return (
//     <>
//       {/* {loading ? "jjjjjjjjjjjjjjjjj" : "mmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm"} */}
//       <div>
//         <UserLevelFilter />
//       </div>
//       <SecurityContainer
//         style={{
//           paddingTop: "2rem",
//         }}
//       >
//         {menuInfo.map((menu) => {
//           // console.log(menu);
//           return (
//             <div style={{ marginBottom: "1rem" }} kye={menu.menu_id}>
//               <MenuDiv>
//                 <div>{menu.menu}</div>
//                 {/* <div>
//                   <Switch color="error" checked={isSwitchOn} />
//                 </div> */}
//               </MenuDiv>

//               <SubMenuDiv>
//                 {menuInfo.map((menu) => (
//                   <div style={{ marginBottom: "1rem" }} key={menu.menu_id}>
//                     <MenuDiv>
//                       <div>{menu.menu}</div>
//                     </MenuDiv>
//                     <SubMenuDiv>
//                       {menu.submenu.map((submenu) => (
//                         <SubMenuPart key={submenu.submenu_id}>
//                           <div>{submenu.submenu_name}</div>
// <div>
//   <Switch
//     color="success"
//     style={
//       {
//         // color: "#128378",
//       }
//     }
//     inputProps={{ "aria-label": "controlled" }}
//     checked={
//       submenu.submenu_id === submenu.sa_mlinks_id &&
//       submenu.active_fg === "Y"
//     }
//     onChange={(event) =>
//       handleSwitchToggle(event, submenu)
//     }
//   />
// </div>
//                         </SubMenuPart>
//                       ))}
//                     </SubMenuDiv>
//                     <Line />
//                   </div>
//                 ))}
//                 {/* {menu.submenu.map((submenu) => {
//                   return (
//                     <SubMenuPart key={Math.random()}>
//                       <div>{submenu.submenu_name}</div>
// <div>
//   <Switch
//     color="success"
//     style={
//       {
//         // color: "#128378",
//       }
//     }
//     inputProps={{ "aria-label": "controlled" }}
//     onChange={(event) =>
//       handleSwitchToggle(event, submenu)
//     }
//   />
// </div>
//                     </SubMenuPart>
//                   );
//                 })} */}
//               </SubMenuDiv>

//               <Line />
//             </div>
//           );
//         })}
//       </SecurityContainer>
//     </>
//   );
// };

// export default LevelManagement;
